import Alert from '../../../../../ui/alert/Alert';
import { FC } from 'react';
import styles from './NotFoundAlert.module.scss';
import { getClassNames } from '../../../../../helpers/classHelpers';

const NotFoundAlert: FC<{ message: string; padTop?: boolean; }> = ({ message, padTop }) => {
    return (
        <Alert className={getClassNames([styles['not-found'], padTop && styles['padding-top']])} headline={message} />
    );
};

export default NotFoundAlert;